import { Carousel } from '@/general/components/Carousel/Carousel';
import { IntersectionObserverHandler } from '@/general/components/IntersectionObserverHandler/IntersectionObserverHandler';
import { pushToDataLayerFeatureEngagement } from '@/utils/pushToDataLayerFeatureEngagement';
import { ComponentProps, useEffect } from 'react';

type Props = {
  tiles: ComponentProps<typeof Carousel>['tiles'];
  carouselName?: string;
};

export const RecentlyViewedCarouselSection = ({ tiles, carouselName }: Props) => {
  useEffect(() => {
    pushToDataLayerFeatureEngagement({
      event: 'feature_engagement',
      payload: {
        type: 'load',
        feature: 'recentlyViewed',
        component: 'carousel',
      },
    });
  }, []);
  return (
    <IntersectionObserverHandler
      margins="-50%"
      onIntersecting={() => {
        pushToDataLayerFeatureEngagement({
          event: 'feature_engagement',
          payload: {
            type: 'view',
            feature: 'recentlyViewed',
            component: 'carousel',
          },
        });
      }}
    >
      <Carousel tiles={tiles} carouselName={carouselName} variant="recently-viewed" />
    </IntersectionObserverHandler>
  );
};
